import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Button from "react-bootstrap/Button";
import { Modal, Dropdown, DropdownButton } from "react-bootstrap";
import ToggleButton from "react-bootstrap/ToggleButton";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import Tabs from "react-bootstrap/Tabs";
import WelcomeMessage from "../Dashboard/WelcomeMessage";
import BuildSideBarMenu from "../../components/BuildAssistant/BuildSideBarMenu";
import "./assistants.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import Utils from "../../utils";
import config from "../../config";
import { Link } from "react-router-dom";
import { PaginationControl } from "react-bootstrap-pagination-control";
import FileInput from "react-fine-uploader/file-input";
import ReadMore from "../../components/ReadMore/ReadMore";
import { t } from "i18next";
import { Spinner, Table } from "react-bootstrap";

import _ from "lodash";

import {
  createCategories,
  categories,
  changeStatusCategories,
} from "../../api/assistant.api";
import { toast } from "react-toastify";
import CustomPagination from "../common/CustomPagination";

function Categories() {
  const limit = 10;
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [totallength, setTotallength] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [categoriesState, setCategoriesState] = useState();
  const [showToggle, setShowToggle] = useState(false);
  const [status, setStatus] = useState(false); // false
  const [editCategory, setEditCategory] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryId, setCategoryId] = useState(0);
  const [categoryDescription, setCategoryDescription] = useState("");
  const [categoryActive, setCategoryActive] = useState(true);
  const [categoryCreated, setCategoryCreated] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [categorySwitches, setCategorySwitches] = useState({});
  const [errors, setErrors] = useState({}); // Track validation errors
 
  const navigate = useNavigate();

  const fetchCategory = async () => {
    const payload = {
      //   "buildBy": buildBy, // or 'me' this only required field
      //   "sortBy": "createdAt",
      // sortOrder: "asc",
      //   // "search": "gp",
      //   // "isPublish": true,
      //   // "active": true,
      page: page,
      limit: limit,
      //   ...(buildBy !== "me" && { isPublish: true })
    };
    try {
      const response = await categories(payload);
      const categoriesData = response.data?.categories || [];
      setCategoriesState(categoriesData);
      setTotallength(response.data?.totalDocuments);
      setTotalPages(response.data?.totalPages);
     
      const switches = {};
      categoriesData.forEach((category) => {
        switches[category.categoryid] = category.active || false;
      });
      setCategorySwitches(switches);
    } catch (error) {
      toast.error(`${t("somethingWentWrong")}`);
      
    }
  };
  useEffect(() => {
   

    fetchCategory();

    
  }, [page]);
  const handleCloseModal = () => {
    setShow(false);
    resetForm(); // Reset the form to clear the input fields and errors
  };
  const validateForm = () => {
    const newErrors = {};
    if (!categoryName.trim()) {
      newErrors.categoryName = t("Category name is required");
    }
    if (!categoryDescription.trim()) {
      newErrors.categoryDescription = t("Category description is required");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Check if any errors exist
  };
  const handleSave = async () => {
    if (!validateForm()) {
      return; // Stop if validation fails
    }
  
    const payload = {
      categoryname: categoryName, 
      categorydescription: categoryDescription, 
      status: true,
    };
  
    try {
      if (editCategory) {
        await changeStatusCategories(payload, categoryId);
        toast.success("Category updated successfully");
      } else {
        await createCategories(payload);
        toast.success("Category created successfully");
      }
  
      fetchCategory(); 
      setShow(false); 
      resetForm();
    } catch (error) {
      
      // console.log(error?.response?.data?.message)
      if (error?.response?.status === 400 || error === "Category already exists") {
        toast.error("Category already exists");
      } else {
        toast.error(t("somethingWentWrong"));
      }
    }
  };
  
  
  
  
  const resetForm = () => {
    setCategoryName("");
    setCategoryDescription("");
    setCategoryActive(true); 
    setEditCategory(false); // Reset edit mode when adding a new category
    setErrors({}); // Clear validation errors
  };
  
  const handleStatusChange = async (e) => {
    let status = e === "true" ? true : false;
    const payload = {
      status: status,
    };

    try {
      const response = await changeStatusCategories(payload, categoryId);
      toast.success(t("categoryStatus"));
      // setCategoryCreated(true)
      fetchCategory();
      // setStatus(true)
      setShowToggle(false); // Close the modal on success
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    }
  };

  const changeStatus = (id) => {
    setCategoryId(id);
    setShowToggle(true);
  };

  const handleSelect = (eventKey) => {
    handleStatusChange(eventKey);
  };
  const handleEdit = (categoryState) => {
    // Set form values based on the selected category for editing
    setCategoryName(categoryState.categoryname);
    setCategoryDescription(categoryState.categorydescription);
    setCategoryId(categoryState.categoryid);
    setEditCategory(true); // Switch to edit mode
    setShow(true); // Show modal
  };
  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const handleNextPage = (len) => {
    if (page < len) {
      setPage(page + 1);
    }
  };
  const handleToggle = async (categoryId, currentStatus) => {
    const newStatus = !currentStatus;

    try {
      const payload = { status: newStatus };
      await changeStatusCategories(payload, categoryId);
      toast.success(t("categoryStatusUpdated"));
      fetchCategory();
      // Update local switch state
      setCategorySwitches((prevState) => ({
        ...prevState,
        [categoryId]: newStatus,
      }));

      // Optionally, update the categories state to reflect the change
      setCategoriesState((prevCategories) =>
        prevCategories.map((category) =>
          category._id === categoryId
            ? { ...category, active: newStatus }
            : category
        )
      );
      
    } catch (error) {
      toast.error(t("somethingWentWrong"));
      fetchCategory();  
    }
  };
  // console.log("category page")
  const handleAddCategory = () => {
    resetForm(); // Ensure form is cleared
    setEditCategory(false); // Set to "Add Category" mode
    setShow(true); // Show modal
  };

  return (
    <>
      <section className="custom-table">
      <WelcomeMessage />
        <section className="pt-3 pb-5">
          <div className="build-assistant-container">
            {/* <div className="title-box-assistant d-flex align-items-center justify-content-between welcome-message">
              <h1 className="msg-title vuild-title mb-0 msg-title"> {t("categorymgn")}</h1>

            </div> */}
          
             <div className="d-flex justify-content-end mt-3 mb-3">
              <button
                type="submit"
                className="custom-bt btn-primary active"
                onClick={() => setShow(true)}
              >
                {t("Add category")}
              </button>
            </div>
            <div className="pdf-wrapper">
              {categoriesState?.length < 0 ? (
                <div className="pdf-list-assitant"> {t("noAddedApps")}</div>
              ) : (
                categoriesState?.map((categoryState) => (
                  <div className="pdf-list-assitant" key={categoryState.categoryid}>
                    <div className="pdf-icon-box">
                      {categoryState.thumbnailUrl &&
                      typeof categoryState.thumbnailUrl === "string" ? (
                        <img
                          style={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "100%",
                          }}
                          src={categoryState.thumbnailUrl}
                          alt=""
                        />
                      ) : (
                        <svg
                          width="56"
                          height="56"
                          viewBox="0 0 56 56"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="56" height="56" rx="28" fill="#F2F4F7" />
                          <g opacity="0.08">
                            <rect
                              x="0.375"
                              y="0.375"
                              width="55.25"
                              height="55.25"
                              rx="27.625"
                              stroke="#101828"
                              strokeWidth="0.75"
                            />
                          </g>
                          <path
                            d="M30.6667 15.026V20.5334C30.6667 21.2802 30.6667 21.6535 30.812 21.9388C30.9399 22.1896 31.1438 22.3936 31.3947 22.5214C31.6799 22.6668 32.0533 22.6668 32.8 22.6668H38.3074M30.6667 34.6667H22.6667M33.3334 29.3333H22.6667M38.6667 25.3176V34.9333C38.6667 37.1735 38.6667 38.2937 38.2307 39.1493C37.8472 39.9019 37.2353 40.5139 36.4827 40.8974C35.627 41.3333 34.5069 41.3333 32.2667 41.3333H23.7334C21.4932 41.3333 20.3731 41.3333 19.5174 40.8974C18.7648 40.5139 18.1528 39.9019 17.7693 39.1493C17.3334 38.2937 17.3334 37.1735 17.3334 34.9333V21.0667C17.3334 18.8265 17.3334 17.7064 17.7693 16.8507C18.1528 16.0981 18.7648 15.4861 19.5174 15.1026C20.3731 14.6667 21.4932 14.6667 23.7334 14.6667H28.0157C28.9941 14.6667 29.4833 14.6667 29.9436 14.7772C30.3518 14.8752 30.742 15.0368 31.0998 15.2561C31.5035 15.5035 31.8494 15.8494 32.5412 16.5412L36.7922 20.7922C37.484 21.484 37.8299 21.8299 38.0773 22.2335C38.2966 22.5914 38.4582 22.9816 38.5562 23.3897C38.6667 23.8501 38.6667 24.3393 38.6667 25.3176Z"
                            stroke="#475467"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="pdf-info-box">
                      <div className="d-flex pdf-title-ass">
                        <div className="pdf-name">
                          {categoryState.categoryname}
                        </div>
                        {/* <ul className="pills-pdf mb-0"> */}
                          {/* <li
                            className={`${
                              categoryState.active ? "poubli" : "ed"
                            }`}
                          >
                            {categoryState.active === true
                              ? t("active")
                              : t("inactive")}
                          </li> */}
                          {/* <li className="ed"> {t("published")} </li> */}
                          {/* {categoryState.isPublish ? (
                                <li className="ed"> {t("published")} </li>
                              ) : (
                                <li className="unpubli">
                                  {" "}
                                  {t("unpublished")}{" "}
                                </li>
                              )} */}
                          {/* <li className="cop">4 copies</li> */}
                        {/* </ul> */}
                      </div>
                      <p className="mb-0">
                        {categoryState.categorydescription}
                      </p>
                    </div>
                    <div className="btn-pdf-wrapper">
                      <div className="form-swd">
                      <button
                            type="submit"
                            className="custom-bt btn-primary"
                            onClick={() => handleEdit(categoryState)}
                          >
                            {t("edit")}
                          </button>
                            {/* <Form.Check
                        type="switch"
                        id={`custom-switch-${categoryState.categoryid}`}
                        // checked={categorySwitches[categoryState.categoryid] ?? categoryState.active}
                      
                        checked={categorySwitches[categoryState.categoryid] || false}
                        onChange={() =>
                          handleToggle(
                            categoryState.categoryid,
                            categorySwitches[categoryState.categoryid]
                          )
                        }
                      /> */}
                      </div>
                     
                    </div>
                  </div>
                ))
              )}
            </div>

            {
              totallength > 10 &&
              <CustomPagination handlePageChange = {setPage}  between = {4} totalLength = {totallength} totalPages = {totalPages}/>
            }
            {/* </Tab> */}
            {/* </Tabs> */}
          </div>
        </section>
      </section>
      {showToggle && (
        <Modal show={showToggle} onHide={() => setShowToggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Select Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DropdownButton
              id="dropdown-category"
              // title={selectedCategory}
              onSelect={handleSelect}
            >
              <Dropdown.Item eventKey="true">{t("active")}</Dropdown.Item>
              <Dropdown.Item eventKey="false">{t("inactive")}</Dropdown.Item>
            </DropdownButton>
          </Modal.Body>
        </Modal>
      )}

<Modal
  show={show}
  onHide={handleCloseModal} // Ensure form is reset when modal is closed
  centered
>
  <Modal.Header closeButton>
    <Modal.Title className="fw-bold modal-title h4">{editCategory ? t("Edit Category") : t("Add Category")}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form className="d-flex flex-column gap-2">
      <Form.Group controlId="categoryName">
        <Form.Label>{t("categoryName")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("enterCategoryName")}
          // className="form-control select-input"
          value={categoryName}
          onChange={(e) => {
            const value = e.target.value;
            // Only allow letters, numbers, and spaces
            const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
            setCategoryName(filteredValue);
          }}
          isInvalid={!!errors.categoryName} // Add validation state
        />
        <Form.Control.Feedback type="invalid">
          {errors.categoryName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="description">
        <Form.Label>{t("description")}</Form.Label>
        <Form.Control
          type="text"
          className="form-control select-input"
          placeholder={t("enterDescription")}
          value={categoryDescription}
          onChange={(e) => {
            const value = e.target.value;
            // Only allow letters, numbers, and spaces
            const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
            setCategoryDescription(filteredValue);
          }}
          isInvalid={!!errors.categoryDescription} // Add validation state
        />
        <Form.Control.Feedback type="invalid">
          {errors.categoryDescription}
        </Form.Control.Feedback>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <button className="builder-btn " onClick={handleCloseModal}>{t("Close")}</button>
    <button className="builder-btn active" onClick={handleSave}>{t("Save")}</button>
  </Modal.Footer>
</Modal>
    </>
  );
}

export default Categories;
